import {PureComponent} from 'react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

import {generate} from '../../../../routes.js'

import './Categories.scss'

export default class Categories extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    categories: PropTypes.array
  }

  static defaultProps = {
    className: '',
    categories: []
  }

  generateLink = (category) => {
    return generate({
      name: 'blog-category',
      parameters: {
        slug: category.slug
      }
    })
  }

  render() {
    return (
      <div className={`categories-list ${this.props.className}`}>
        <h3>Catégories</h3>
        <ul>
          {this.props.categories.map((category) => (
            <li key={category.slug}>
              <Link to={this.generateLink(category)}>
                {category.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}
